<template>
  <div class="flex">
    <div class="image-box">
      <el-upload
        :action="action"
        name="upload_field"
        :show-file-list="showFileList"
        :file-list="fileList"
        :on-success="success"
        :on-error="error"
        :before-upload="before"
        :headers="headers"
        :on-remove="handleRemove"
        :data="formData"
        :accept="accept"
        :multiple="multiple"
        :limit="limit"
      >
        <el-button size="medium" type="primary" :disabled="disabled">Click Upload</el-button>
      </el-upload>
    </div>
    <!-- <div v-if="name && tips" class="ml10">{{ name }}</div> -->
  </div>
</template>

<script>
import { uploadFile } from "@/common/ev";
import { Warning } from "_c";
export default {
  name: "upload-bar",
  inject: ["tableMixins"],
  props: {
    action: {
      type: String,
      default: uploadFile
    },
    data: {
      type: Object,
      default: {}
    },
    fileName: {
      type: String,
      default: ""
    },

    showFileList: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uploadName: {
      type: Boolean,
      default: false
    },
    tips: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    dialogName: {
      type: String,
      default: "formEdit"
    }
  },
  data() {
    return {
      limit: 1,
      fileList: [],
      name: "",
      formData: {}
    };
  },
  computed: {
    headers() {
      return {
        Authorization: localStorage.Authorization
      };
    }
  },
  watch: {
    "tableMixins.formEdit": {
      handler(val) {
        if (!val) {
          this.name = "";
          this.formData = {};
        } else {
          this.name = this.fileName;
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.name = "";
  },
  methods: {
    passData(fileList) {
      let fileUrl = "",
        path = "";
      fileList.forEach(item => {
        fileUrl = item.response.data.fileinfo.full_http_url;
        path = item.response.data.fileinfo.path;
      });

      this.$emit("change", {
        url: fileUrl,
        path: path
      });
    },
    handleRemove(file, fileList) {
      this.passData(fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    success(rs, file, fileList) {
      if (rs.errno == 0) {
        this.passData(fileList);
      } else {
        this.fileList = [];
        this.$message.error("上传错误");
      }
    },
    error(e) {
      console.log(e);
    },
    before(file) {
      let index = file.name.lastIndexOf(".");
      let name = file.name.slice(0, index);
      this.name = file.name;
      if (this.uploadName) {
        this.formData = {
          file_name: name
        };
      } else {
        this.formData = this.data;
      }

      return new Promise((resolve, reject) => {
        resolve();
        /*                if (file.size / 1024000 > this.fileMaxSize) {
                    Warning({
                        message: `上传大小不超过${this.fileMaxSize}M`,
                        type: 'error',
                    });
                    let e = `上传大小不超过${this.fileMaxSize}M`;
                    reject(e);
                } else if (this.limit.length === 0) {
                    resolve();
                } */
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
